import React from "react";
import InputArea from "../../../common/components/FormFields/InputArea";
import { useFormContext } from "react-hook-form";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import InputField from "../../../common/components/FormFields/InputField";
import CommonInputField from "../../../common/components/CommonInputField";

export default function Habit(props) {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  let smoke = watch("smoke");
  let alohol = watch("alohol");
  let tobacco = watch("tobacco");
  let veg = watch("veg");
  let nonveg = watch("nonveg");
  return (
    <div>
      <div className="flex justify-between bg-[#CFFAFE] rounded-t-md">
        <p className="text-sm font-semibold w-full pl-2 py-2">
          Personal History
        </p>
      </div>
      <div className="block max-h-60 border p-2 overflow-auto pb-3 border-[#D9D9D9] rounded-b-md bg-white px-2">
        <div className="grid gap-2">
          <div className="flex space-x-3 items-center">
            <div className="w-[200px]">
              <fieldset
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                <CheckBoxField
                  style={{
                    padding: "1px",
                    marginLeft: "5px",
                  }}
                  control={control}
                  name="smoke"
                  label="Smoking"
                />
              </fieldset>
            </div>

            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <CommonInputField
                control={control}
                name="smokeDescription"
                disabled={smoke !== true}
              />
            </fieldset>
          </div>

          <div className="flex space-x-3 items-center">
            <div className="w-[200px] ">
              <fieldset
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                <CheckBoxField
                  style={{
                    padding: "1px",
                    marginLeft: "5px",
                  }}
                  control={control}
                  name="alohol"
                  label="Alcohol"
                />
              </fieldset>
            </div>

            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <CommonInputField
                control={control}
                name="aloholDescription"
                disabled={alohol !== true}
              />
            </fieldset>
          </div>
          <div className="flex space-x-3 items-center">
            <div className="w-[200px]">
              <fieldset
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                <CheckBoxField
                  style={{
                    padding: "1px",
                    marginLeft: "5px",
                  }}
                  control={control}
                  name="tobacco"
                  label="Tobacco"
                />
              </fieldset>
            </div>

            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <CommonInputField
                control={control}
                name="tobaccoDiseaseDescription"
                // label="mm"
                disabled={tobacco !== true}
              />
            </fieldset>
          </div>
          <div className="flex space-x-3 items-center">
            <div className="w-[200px]">
              <fieldset
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                {/* <label className="text-[14px] pt-1">BP (Diastolic)</label> */}
                <CheckBoxField
                  style={{
                    padding: "1px",
                    marginLeft: "5px",
                  }}
                  control={control}
                  name="veg"
                  label="Veg"
                />
              </fieldset>
            </div>

            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <CommonInputField
                control={control}
                name="vegDescription"
                disabled={veg !== true}
              />
            </fieldset>

            {/* <Divider orientation="vertical" /> */}
          </div>
          <div className="flex space-x-3 items-center">
            <div className="w-[200px]">
              <fieldset
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                {/* <label className="text-[14px] pt-1">BP (Diastolic)</label> */}
                <CheckBoxField
                  style={{
                    padding: "1px",
                    marginLeft: "5px",
                  }}
                  control={control}
                  name="nonveg"
                  label="Non-Veg"
                />
              </fieldset>
            </div>

            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <CommonInputField
                control={control}
                name="nonvegDescription"
                disabled={nonveg !== true}
              />
            </fieldset>

            {/* <Divider orientation="vertical" /> */}
          </div>
          {/* <div className="flex space-x-3 items-center">
            <div className="w-[200px]">
              <fieldset
                className="w-full"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              >
                <CheckBoxField
                  control={control}
                  name="otherHabit"
                  label="Other"
                />
              </fieldset>
            </div>

            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField control={control} name="otherHabitDec" />
            </fieldset>
          </div> */}
        </div>
      </div>
    </div>
  );
}

